import { WebPage } from '../types/page.types';
import { AuditResponse } from '../types/seo-audit.types';

const API_GEN_URL = import.meta.env.VITE_API_GEN_URL || 'http://localhost:3000';
const API_SEO_URL = import.meta.env.VITE_API_SEO_URL || 'http://localhost:8000';

export async function fetchPageBySlug(slug: string): Promise<WebPage> {
  const response = await fetch(`${API_GEN_URL}/api/pages/${slug}`);

  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('Page not found');
    }
    throw new Error('Failed to fetch page');
  }

  return response.json();
}

export async function fetchAllPages(): Promise<WebPage[]> {
  const response = await fetch(`${API_GEN_URL}/api/pages`);

  if (!response.ok) {
    throw new Error('Failed to fetch pages');
  }

  return response.json();
}

export async function executeSeoAudit(
  url: string,
  maxPages: number = 100
): Promise<AuditResponse> {
  const response = await fetch(`${API_SEO_URL}/audit`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ url, max_pages: maxPages }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      errorData.message || errorData.error || `HTTP ${response.status}: Failed to execute SEO audit`
    );
  }

  return response.json();
}
